import React, {
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import './ContextMenuLayer.style.scss';

export interface IContextMenuOption {
  text: string;
  onClick: () => void;
}

interface IProps {
  children: ReactNode;
  options?: IContextMenuOption[];
}

const ContextMenuLayer = (props: IProps) => {
  const { children, options } = props;

  const divRef = useRef<HTMLDivElement>(null);

  const timer = useRef<NodeJS.Timeout>();

  const [x, setX] = useState<number>();

  const [y, setY] = useState<number>();

  const [show, setShow] = useState(false);

  const touchStart = useCallback((event: TouchEvent) => {
    timer.current = setTimeout(
      () =>
        handleContextMenu(
          event,
          event.touches[0].pageX,
          event.touches[0].pageY
        ),
      1000
    );
  }, []);

  const touchEnds = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = undefined;
    }
  };

  const handleContextMenu = (
    event: TouchEvent | MouseEvent,
    newX: number,
    newY: number
  ) => {
    event.preventDefault();
    timer.current = undefined;
    setX(newX);
    setY(newY);
    setShow(true);
  };

  const handleClickOutside = useCallback(
    (event: MouseEvent | TouchEvent) => {
      if (show) {
        const contextMenus = document.getElementsByClassName(
          'contextMenuLayer--menu__item'
        );

        let shouldClose = true;

        for (let i = 0; i < contextMenus.length; i++) {
          const openDropdown = contextMenus[i];
          if (openDropdown === event.target) {
            shouldClose = false;
            break;
          }
        }

        setShow(!shouldClose);
      }
    },
    [show]
  );

  useEffect(() => {
    const current = divRef.current;

    const handleContextMenu2 = (event: MouseEvent) =>
      handleContextMenu(event, event.pageX, event.pageY);

    current?.addEventListener('contextmenu', handleContextMenu2);

    current?.addEventListener('touchstart', touchStart);

    current?.addEventListener('touchend', touchEnds);

    window.addEventListener('mousedown', handleClickOutside);

    window.addEventListener('touchstart', handleClickOutside);

    return () => {
      current?.removeEventListener('contextmenu', handleContextMenu2);

      current?.removeEventListener('touchstart', touchStart);

      current?.removeEventListener('touchend', touchEnds);

      window.removeEventListener('mousedown', handleClickOutside);

      window.removeEventListener('touchstart', handleClickOutside);
    };
  }, [handleClickOutside, touchStart]);

  return (
    <div ref={divRef} className="contextMenuLayer">
      {show && options && options.length > 0 && (
        <div
          style={{
            top: y,
            left: x,
          }}
          className="contextMenuLayer--menu"
        >
          {options?.map((option) => {
            const handleOnClick = () => {
              setShow(false);
              option.onClick();
            };

            return (
              <div
                className="contextMenuLayer--menu__item"
                key={option.text}
                onClick={handleOnClick}
              >
                {option.text}
              </div>
            );
          })}
        </div>
      )}
      {children}
    </div>
  );
};

export default ContextMenuLayer;
